import styled from 'styled-components';
import { Radio } from 'ui/radio';
import { spacing } from 'ui/theme';
import { body2, body2Bold } from 'ui/theme/typography';
import { Modal, ModalBody } from 'ui/modal';

// the copy to another project can trigger a dropdown that needs to overflow
// styles from CopyTemplateModal file
export const OverflowModal = styled(Modal)`
  overflow: visible;
`;
export const OverflowBody = styled(ModalBody)`
  overflow: visible;
  overflow-wrap: normal;
`;

// styles are identical to the CopyTemplateModal.styles file
export const Spacer = styled.div`
  height: ${spacing.plusHalf};
  width: 100%;
  display: block;
`;

export const BaseContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const RadioContainer = styled(BaseContainer)`
  padding: ${spacing.threeQuarter} 0 0 ${spacing.quarter};
  gap: ${spacing.x3};
`;

export const RadioOption = styled(BaseContainer)`
  margin-bottom: 0;
`;

export const Body2Span = styled.span`
  ${body2}
  margin: 0;
`;

export const Body2Label = styled.label`
  ${body2Bold}
`;

export const StyledRadio = styled(Radio)`
  margin-right: ${spacing.threeQuarter};
`;
